import React from 'react';
import { useData } from '../../context/DataContext';
import { useAuth } from '../../context/AuthContext';
import { CURRENT_CONTENT_SEASON } from '../../utils/seasonContent';

export default function LessonSummaries() {
  const { announcements = [] } = useData();
  const { user } = useAuth();
  const activeCourseId = user?.courseId;
  const activeIntake = user?.intake;

  const summaries = announcements.filter(announcement => {
    const isLesson = (announcement.category || '').toLowerCase() === 'lesson summary';
    if (!isLesson) return false;
    if (!activeCourseId && !activeIntake) return true;
    if (announcement.courseId && activeCourseId) return announcement.courseId === activeCourseId;
    if (announcement.intake && activeIntake) return announcement.intake === activeIntake;
    return !announcement.courseId && !announcement.intake;
  });

  const getAnnouncementDate = (announcement) => {
    if (announcement.date) return announcement.date;
    const createdAt = announcement.createdAt?.toDate?.();
    if (createdAt) return createdAt.toLocaleDateString();
    return '';
  };

  return (
    <div>
      <div className="page-header">
        <h1 className="page-title">Lesson Summaries</h1>
        <p className="page-subtitle">Review the latest {CURRENT_CONTENT_SEASON} lesson summaries from your teachers.</p>
      </div>

      {summaries.length === 0 && (
        <div className="card" style={{ textAlign: 'center', padding: '48px' }}>
          <div style={{ color: 'var(--gray-500)' }}>No lesson summaries yet.</div>
        </div>
      )}

      <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
        {summaries.map((announcement) => (
          <div key={announcement.id} className="card">
            <div className="card-body">
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '12px' }}>
                <div style={{ fontSize: '0.75rem', color: 'var(--gray-500)' }}>
                  {getAnnouncementDate(announcement)}
                </div>
                <span style={{ fontSize: '0.75rem', color: 'var(--gray-500)' }}>
                  By {announcement.author || 'School of SHEM'}
                </span>
              </div>
              <h3 style={{ fontSize: '1.125rem', marginBottom: '12px' }}>{announcement.title}</h3>
              <p style={{ color: 'var(--gray-600)', lineHeight: 1.7, marginBottom: 0 }}>
                {announcement.content}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
